<template>
  <div ref="chartDom" id="chart" style="height:100%;"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { BarChart,LineChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers';
import { formulaMixins } from "../unitls";
echarts.use([TitleComponent, TooltipComponent, GridComponent, BarChart,LineChart, CanvasRenderer,LegendComponent])
export default {
  props:['result','filterVal'],
  mixins: [formulaMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      option: {
        grid: {
          left: 20,
          right: 280,
          bottom: 40,
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 20
        }, {
          start: 0,
          end: 20
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          textStyle:{
            width:200,
            height:20,
            fontSize:12,
            lineOverflow:'truncate',
            lineHeight:18,
            ellipsis :'..',
            overflow:'break',
          },
          itemWidth:16,
          itemHeight:10,
          width:200,
          height:'90%',
          right: 10,
          top: 20,
          bottom: 200,
          data: ['蒸发量', '降水量', '平均温度']
        },
        xAxis:{
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          // boundaryGap: false,
          // axisPointer: {
          //   type: 'shadow'
          // },
          // axisLine: {onZero: false},
        },
        yAxis:[{
          type: 'value',
          name: '数值',
          },
          {
            // min: 2000,
            // max: 3100,
            type: 'value',
            name: '价格',
            axisLabel: {
              formatter: '{value} 元'
            }
          }
        ],
        series: [
          {
            name: '蒸发量',
            type: 'line',
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
          },
        ]
      },
    }
  },
  created(){
    this.initOption()
    // this.initTableData(true)
  },
  watch:{
    filterVal(){
      this.initOption(true)
    }
  },
  methods:{
    initTableData(lst){
      // const {ladderList} = this.result
      // let arr = rawResList[0]
      let list = []
      let first = {}
      lst.forEach(el => {
        let flag = false
        let numArr = []
        if(this.filterVal === '所有原料'){
          flag = false
        }else if(this.filterVal === '组分有差异'){
          el.data.forEach(val => {
            if(!numArr.includes(val)) numArr.push(val)
          })
          if(numArr.length > 1){
            flag = false
          }else{
            flag = true
          }
        }else if(this.filterVal === '组分无差异'){
          el.data.forEach(val => {
            if(!numArr.includes(val) && val != 0) numArr.push(val)
          })
          if(numArr.length === 1){
            flag = false
          }else{
            flag = true
          }
        }else if(this.filterVal === '拒绝原料'){
          el.data.forEach(val => {
            if(val > 0){
              flag = true
            }
          })
        }

        // const {id} = this.$route.query
        if(el.code === this.rawSelect.rawCode) {
          flag = true
          first = el
        }
        if(!flag) list.push(el)
      })
      list.unshift(first)
      return list
    },
    initOption(){
      const {ladderList,rawResList} = this.result
      // let min = ladderList[0]
      // let max = ladderList[ladderList.length - 1]
      
      if(ladderList && rawResList) {
        let series = rawResList[0].map((i) => {
          return { 
            name: this.overseasFlag == '1' ? (i.aliasName || i.name) : i.name,
            data:[]
          }
        })
        console.log('rawResList',rawResList)
        rawResList.forEach((item) => {
          item.forEach((i,id) => {
            series[id] = {
              name: this.overseasFlag == '1' ? (i.aliasName || i.name) : i.name,
              code: i.code,
              type: id === 0 ? 'bar' : 'line',
              yAxisIndex: id === 0 ? 1 : 0,
              data:[...series[id].data, i.uasge]
            }
          })
        })
        series = this.initTableData(series)
        let first = rawResList[0] ? rawResList[0][0] ? rawResList[0][0] : [] : [] || []
        let minNum = 0
        let maxNum = 0
        ladderList.forEach((el,ind) => {
          if(ind === 0){
            minNum = first[el]
            maxNum = first[el]
          }
          minNum = Math.min(first[el], minNum)
          maxNum = Math.max(first[el], maxNum)
        })
        this.option.xAxis.data = ladderList
        this.option.xAxis.scale = true
        if(minNum === 0){
          this.option.yAxis[1].min = 0
        }else{
          this.option.yAxis[1].min = minNum % 10 === 0 ? (parseInt(minNum / 10) - 1) * 10 : parseInt(minNum / 10) * 10
        }
        if(maxNum === 0){
          this.option.yAxis[1].max = 10
        }else{
          this.option.yAxis[1].max = Math.ceil(maxNum / 10) *10
        }
        this.option.legend.data = series.map(i => this.overseasFlag == '1' ? (i.aliasName || i.name) : i.name)
        
        this.option.series = series
        this.$nextTick(()=> {
          this.initChart()
        })
      }
    },
    initChart(){
      this.myChart = echarts.init(document.getElementById('chart'))
      this.myChart.clear()
      this.myChart.setOption(this.option)
    },
    downloadUrlFile(url,fileName){
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.href = url
      if(fileName){
        a.download = fileName
      }
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    },
    downloadChart(){
      const chartImgUrl = this.myChart.getDataURL({
        pixelRatio: 2,backgroundColor: '#fff',type:'png'
      })
      this.downloadUrlFile(chartImgUrl,`${this.detail.taskName}-${new Date().getTime()}`)
    },
  }
}
</script>

<style>

</style>